

// function getSemiFieldError(err: ReactFieldError) {
//   if (!err || typeof err !== 'object') return;

import { toast } from "sonner";

//   let errMsg = Object.entries(err)[0][1];
//   if (errMsg && typeof errMsg === 'object') {
//     errMsg = Object.entries(errMsg)[0][1];
//   }

//   return errMsg;
// }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export function getErrMessage(err: any) {
  return err.response?.data?.message || err.message || err.errMsg || err;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export default (err: any) => {
  const errMsg = getErrMessage(err);
  toast.warning(errMsg);
  return errMsg;
};
